import {
  CreateGradingCriterion,
  GradingCriterion,
} from "../Models/gradingCriteria";
import call from "./call";

export const getGradingCriteria = async (): Promise<GradingCriterion[]> => {
  const { data } = await call.get("/v1/grading_criterion/", {
    snack: { error: "gradingCriteria.fetchError" },
  });
  return data;
};

export const getGradingCriterion = async (
  id: number,
): Promise<GradingCriterion> => {
  const { data } = await call.get(`/v1/grading_criterion/${id}/`, {
    snack: { error: "gradingCriteria.fetchError" },
  });
  return data;
};

export const createGradingCriterion = async (
  payload: CreateGradingCriterion,
) => {
  const { data } = await call.post("/v1/grading_criterion/", payload, {
    snack: {
      success: "gradingCriteria.createSuccess",
      error: "gradingCriteria.createError",
    },
  });
  return data;
};

export const updateGradingCriterion = async (
  id: number,
  payload: CreateGradingCriterion,
) => {
  const { data } = await call.put(`/v1/grading_criterion/${id}/`, payload, {
    snack: {
      success: "gradingCriteria.updateSuccess",
      error: "gradingCriteria.updateError",
    },
  });
  return data;
};

export const deleteGradingCriterion = async (id: number) => {
  const { data } = await call.delete(`/v1/grading_criterion/${id}/`, {
    snack: {
      success: "gradingCriteria.deleteSuccess",
      error: "gradingCriteria.deleteError",
    },
  });
  return data;
};

export const setDefaultGradingCriterion = async (id: number) => {
  const { data } = await call.put(
    `/v1/grading_criterion/default/${id}/`,
    {},
    {
      snack: {
        success: "gradingCriteria.defaultSuccess",
        error: "gradingCriteria.defaultError",
      },
    },
  );
  return data;
};
